import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faPhone, 
  faEnvelope, 
  faMapMarkerAlt 
} from '@fortawesome/free-solid-svg-icons';
import {
  faFacebook,
  faLinkedin,
  faInstagram
} from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';
import './Footer.css';

// Usamos el logo desde la carpeta public/images
const logoPath = `${process.env.PUBLIC_URL}/images/logos/Logo_PROMEDIC_Blanco-07.png`;

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <Container>
        <Row className="footer-top">
          <Col lg={4} md={6} className="footer-info mb-4">
            <div className="footer-logo-container">
              <img 
                src={logoPath} 
                alt={t('footer.logoAlt', 'ProMedic Group')}
                className="footer-logo" 
                height="75"
              />
              <div className="footer-brand">
                <span className="footer-brand-name">{t('footer.brandName', 'PROMEDIC')}</span>
                <span className="footer-brand-tagline">{t('footer.brandTagline', 'GROUP')}</span>
              </div>
            </div>
            <p>
              {t('footer.description', 'ProMedic offers specialized electromechanical maintenance services for the medical industry, providing professional, high-quality solutions that ensure the proper functioning and safety of medical equipment and facilities.')}
            </p>
            <div className="social-links">
              <button type="button" className="social-link-btn" aria-label="Facebook">
                <FontAwesomeIcon icon={faFacebook} />
              </button>
              <button type="button" className="social-link-btn" aria-label="LinkedIn">
                <FontAwesomeIcon icon={faLinkedin} />
              </button>
              <button type="button" className="social-link-btn" aria-label="Instagram">
                <FontAwesomeIcon icon={faInstagram} />
              </button>
            </div>
          </Col>

          <Col lg={2} md={6} className="footer-links mb-4">
            <h4>{t('footer.quickLinksTitle', 'Quick Links')}</h4>
            <ul>
              <li>
                <Link to="/">{t('nav.home', 'Inicio')}</Link>
              </li>
              <li>
                <Link to="/servicios">{t('nav.services', 'Servicios')}</Link>
              </li>
              <li>
                <Link to="/industrias">{t('nav.industries', 'Industrias')}</Link>
              </li>
              <li>
                <Link to="/nosotros">{t('nav.about', 'Nosotros')}</Link>
              </li>
              <li>
                <Link to="/contacto">{t('nav.contact', 'Contacto')}</Link>
              </li>
            </ul>
          </Col>

          <Col lg={2} md={6} className="footer-links mb-4">
            <h4>{t('footer.moreLinksTitle', 'Más Enlaces')}</h4>
            <ul>
              <li>
                <Link to="/terminos">{t('footer.termsOfServiceLink', 'Términos de Servicio')}</Link>
              </li>
              <li>
                <Link to="/privacidad">{t('footer.privacyPolicyLink', 'Política de Privacidad')}</Link>
              </li>
            </ul>
          </Col>

          <Col lg={4} md={6} className="footer-contact mb-4">
            <h4>{t('footer.contactUsTitle', 'Contact Us')}</h4>
            <p>
              <FontAwesomeIcon icon={faMapMarkerAlt} className="me-2" />
              {t('footer.addressLine1', 'Costa Rica, Santa Ana, Brasil')}<br />
              {t('footer.addressLine2', 'Legal ID: 3-102-924057')}
            </p>
            <p>
              <FontAwesomeIcon icon={faPhone} className="me-2" />
              <a href="tel:+50688377017">+506 8837-7017</a>
            </p>
            <p>
              <FontAwesomeIcon icon={faEnvelope} className="me-2" />
              <a href="mailto:jorge.murillo@promedicgroup.com">jorge.murillo@promedicgroup.com</a>
            </p>
          </Col>
        </Row>

        <hr className="footer-divider" />

        <div className="footer-bottom">
          <p className="thank-you-message mb-2">
            {t('footer.thankYouMessage', 'Thank You For Choosing Our Services')}
          </p>
          <p className="copyright" dangerouslySetInnerHTML={{ __html: t('footer.copyright', { year: currentYear, defaultValue: `&copy; ${currentYear} <strong>ProMedic Group</strong>. All rights reserved.` }) }} />
        </div>
      </Container>
    </footer>
  );
};

export default Footer; 